"use client";
import { useLocale, useTranslations } from "next-intl";
import Link from "next/link";

export default function PropertiesNavigate({
  name,
}: {
  name: string | undefined;
}) {
  const t = useTranslations("Nav");
  const locale = useLocale();

  return (
    <div className="flex items-center gap-2 mb-6 select-none text-sm sm:text-lg">
      <Link href={"/"} className=" font-bold text-dark/60">
        {t("home")}
      </Link>
      <span>{locale === "en" ? ">" : "<"}</span>
      <Link href={"/properties"} className=" font-bold text-dark/60">
        {t("properties")}
      </Link>
      <span className="text-lg">{locale === "en" ? ">" : "<"}</span>
      <h2 className=" font-bold text-main">{name}</h2>
    </div>
  );
}
